import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Phone, ClipboardList } from 'lucide-react';

export const FinalCTASection = () => {
  return (
    <section className="py-16 bg-gray-900" data-testid="final-cta-section">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Upgrade Your Roof?
          </h2>
          
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Contact Dezire Metal Roofing today to book a free inspection and quote for your metal roofing project. We&apos;ll help you find the right solution for your home.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/book-inspection">
              <Button
                size="lg"
                className="bg-primary hover:bg-accent text-white text-lg px-8 py-6"
                data-testid="final-cta-book-btn"
              >
                <ClipboardList className="w-5 h-5 mr-2" />
                Book a Free Inspection
              </Button>
            </Link>
            <a href="/call">
              <Button
                size="lg"
                variant="outline"
                className="border-white text-white hover:bg-white hover:text-gray-900 text-lg px-8 py-6"
                data-testid="final-cta-call-btn"
              >
                <Phone className="w-5 h-5 mr-2" />
                Call 0433 973 844
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
